module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "topnavbar-wrapper"
  }, [_c('nav', {
    staticClass: "navbar topnavbar",
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "hamburger-menu",
    attrs: {
      "aria-label": "Toggle menu"
    },
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('span', {
    staticClass: "hamburger-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "hamburger-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "hamburger-icon"
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "nav-wrapper"
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "dropdown dropdown-list"
  }, [_c('a', {
    staticClass: "dropdown-list--account",
    attrs: {
      "href": "#",
      "id": "user-block-toggle",
      "data-toggle": "dropdown",
      "aria-expanded": "true"
    }
  }, [_c('div', {
    staticClass: "dropdown-list--account__info"
  }, [(_vm.activeAccount) ? _c('strong', [_vm._v(_vm._s(_vm.activeAccount.accountName))]) : _vm._e(), _vm._v(" "), (_vm.activeAccount) ? _c('span', {
    staticClass: "user-block-role"
  }, [_vm._v(_vm._s(_vm.getAccountDescription(_vm.activeAccount.accountType)))]) : _vm._e(), _vm._v(" "), (!_vm.irAdmin && _vm.investorSince) ? _c('span', {
    staticClass: "user-block-investor-since"
  }, [_vm._v("Investor since " + _vm._s(_vm.investorSince))]) : _vm._e()]), _vm._v(" "), _c('b', {
    staticClass: "dropdown-list--account__icon icon-arrow-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu animated flipInX"
  }, [_c('li', [_c('div', {
    staticClass: "list-group"
  }, [_c('div', {
    staticClass: "list-group-item list-group-item--current"
  }, [_c('div', {
    staticClass: "media-box"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [(_vm.activeAccount) ? _c('img', {
    staticClass: "img-thumbnail img-circle",
    attrs: {
      "src": _vm.getAccountImgUrl(_vm.activeAccount.accountType),
      "alt": "Avatar",
      "width": "60",
      "height": "60"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "media-box-body clearfix"
  }, [(_vm.activeAccount) ? _c('p', {
    staticClass: "m0"
  }, [_vm._v(_vm._s(_vm.activeAccount.accountName))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "m0 text-muted"
  }, [(_vm.activeAccount) ? _c('small', [_vm._v(_vm._s(_vm.getAccountDescription(_vm.activeAccount.accountType)))]) : _vm._e()])]), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), (!_vm.irAdmin && _vm.user.id !== undefined) ? _c('li', {
    staticClass: "action-widget",
    class: {
      disabled: !_vm.hasBeenCreatedAccount
    },
    attrs: {
      "id": "go-to-account-details"
    }
  }, [_c('router-link', {
    staticClass: "action-link",
    attrs: {
      "to": {
        name: 'InvestorAccountDetails',
        params: {
          id: _vm.activeAccountId
        }
      },
      "title": "Account details"
    }
  }, [_c('em', {
    staticClass: "fa fa-cogs"
  }), _vm._v(" "), (_vm.shouldGoBackButtonBeDisplayed) ? _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Client's account")]) : _vm._e(), _vm._v(" "), (!_vm.shouldGoBackButtonBeDisplayed) ? _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Account details")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.isFinancialAdvisor && _vm.activeAccount.primaryInvestorId !== _vm.user.id) ? _c('li', {
    staticClass: "action-widget",
    attrs: {
      "id": "go-to-profile widget"
    }
  }, [_c('router-link', {
    staticClass: "action-link",
    attrs: {
      "to": {
        name: 'EditUserProfileByAdvisor',
        params: {
          userId: _vm.activeAccount.primaryInvestorId
        }
      },
      "title": "Profile information"
    }
  }, [_c('em', {
    staticClass: "icon-user"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Client's profile")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.irAdmin && _vm.user.id !== undefined) ? _c('li', {
    staticClass: "action-widget",
    class: {
      disabled: !_vm.hasBeenCreatedAccount
    },
    attrs: {
      "id": "go-to-profile widget"
    }
  }, [_c('router-link', {
    staticClass: "action-link",
    attrs: {
      "to": {
        name: 'EditUserProfile'
      },
      "title": "Profile information"
    }
  }, [_c('em', {
    staticClass: "icon-user"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Personal information")])])], 1) : _vm._e(), _vm._v(" "), (_vm.shouldGoBackButtonBeDisplayed) ? _c('li', {
    staticClass: "action-widget list-go-back"
  }, [_c('router-link', {
    staticClass: "list-group-item",
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('div', {
    on: {
      "click": _vm.activateAdvisorAccount
    }
  }, [_c('img', {
    staticClass: "img-thumbnail img-circle",
    attrs: {
      "src": _vm.financialAdvisorAvatar,
      "alt": "Avatar",
      "width": "60",
      "height": "60"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Go back to your financial advisor account")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.user.id !== undefined) ? _c('li', [(_vm.sortedAccounts.length > 1) ? _c('div', {
    staticClass: "list-group list-group--title"
  }, [(!_vm.isFinancialAdvisor) ? _c('h5', {
    staticClass: "text-muted"
  }, [_vm._v("Switch account")]) : _c('h5', {
    staticClass: "text-muted"
  }, [_vm._v("Your clients' accounts")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedAccounts), function(nt, index) {
    return _c('div', {
      key: index,
      staticClass: "list-group"
    }, [(nt.id !== _vm.activeAccount.id && nt.accountType !== _vm.accountTypes.ADVISOR.name) ? _c('router-link', {
      staticClass: "list-group-item",
      attrs: {
        "to": {
          name: 'AccountSummary'
        }
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm.activateAccount(nt)
        }
      }
    }, [_c('a', {
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "media-box"
    }, [_c('div', {
      staticClass: "pull-left"
    }, [_c('img', {
      staticClass: "img-thumbnail img-circle",
      attrs: {
        "src": _vm.getAccountImgUrl(nt.accountType),
        "alt": "Avatar",
        "width": "60",
        "height": "60"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "media-box-body clearfix"
    }, [_c('p', {
      staticClass: "m0"
    }, [_vm._v(_vm._s(nt.accountName))]), _vm._v(" "), _c('p', {
      staticClass: "m0 text-muted"
    }, [_c('small', [_vm._v(_vm._s(_vm.getAccountDescription(nt.accountType)))])])])])])])]) : _vm._e()], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "list-group"
  }, [_c('a', {
    staticClass: "list-group-item list-group-item--logout",
    on: {
      "click": _vm.callLogOut
    }
  }, [_vm._m(3)])])])])])])]), _vm._v(" "), _vm._m(4)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-brand"
  }, [_c('div', {
    staticClass: "brand-logo"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("../assets/calvert-logo.png"),
      "alt": "Calvert Impact Capital",
      "width": "120"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown dropdown-list hide"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('em', {
    staticClass: "icon-bell"
  }), _vm._v(" "), _c('div', {
    staticClass: "label label-danger"
  }, [_vm._v("11")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu animated flipInX"
  }, [_c('li', [_c('div', {
    staticClass: "list-group"
  }, [_c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "media-box"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('em', {
    staticClass: "fa fa-twitter fa-2x text-info"
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-box-body clearfix"
  }, [_c('p', {
    staticClass: "m0"
  }, [_vm._v("New followers")]), _vm._v(" "), _c('p', {
    staticClass: "m0 text-muted"
  }, [_c('small', [_vm._v("1 new follower")])])])])]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "media-box"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('em', {
    staticClass: "fa fa-envelope fa-2x text-warning"
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-box-body clearfix"
  }, [_c('p', {
    staticClass: "m0"
  }, [_vm._v("New e-mails")]), _vm._v(" "), _c('p', {
    staticClass: "m0 text-muted"
  }, [_c('small', [_vm._v("You have 10 new emails")])])])])]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "media-box"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('em', {
    staticClass: "fa fa-tasks fa-2x text-success"
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-box-body clearfix"
  }, [_c('p', {
    staticClass: "m0"
  }, [_vm._v("Pending Tasks")]), _vm._v(" "), _c('p', {
    staticClass: "m0 text-muted"
  }, [_c('small', [_vm._v("11 pending task")])])])])]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#"
    }
  }, [_c('small', [_vm._v("More notifications")]), _vm._v(" "), _c('span', {
    staticClass: "label label-danger pull-right"
  }, [_vm._v("14")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "current-check"
  }, [_c('em', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-box"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('em', {
    staticClass: "icon-logout fa-2x text-info"
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-box-body clearfix"
  }, [_c('p', {
    staticClass: "m0"
  }, [_vm._v("Log out")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "navbar-form",
    attrs: {
      "role": "search",
      "action": "search.html"
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Type and hit enter ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fa fa-times form-control-feedback",
    attrs: {
      "data-search-dismiss": ""
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "hidden btn btn-default",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aae0c29a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopNavBar.vue
// module id = 2193
// module chunks = 1